import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import LoaderButton from '../loader-button/LoaderButton';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
  CardTitle,
  Table,
  Input,
  Label,
  Alert
} from 'reactstrap';
import { FieldGroup } from '../../libs/formLib';

const InputGroupModal = ({
  isReadOnly,
  groupRbacRoles,
  modalOpen,
  setModalOpen,
  loader,
  roles,
  selectedGroup,
  rbacGroups,
  updateGroup
}) => {
  // const [integrationMode, setIntegrationMode] = useState(integrationOptions[0]);
  const [rolePerms, setRolePerms] = useState({});
  const [groupName, setGroupName] = useState('');

  useEffect(() => {
    const groupRoles = {};
    console.log('groupRbacRoles', groupRbacRoles);
    groupRbacRoles.forEach(element => {
      const roleId = element.rbacRoleId;
      groupRoles[roleId] = true;
    });
    setRolePerms(groupRoles);
    setGroupName(selectedGroup.name);
  }, [roles, selectedGroup, groupRbacRoles]);
  // Handle checkboxes for role permissions
  const handleSetRole = (roleId, value) => {
    if (!rolePerms[roleId]) rolePerms[roleId] = {};
    rolePerms[roleId] = value;
    setRolePerms({ ...rolePerms });
  };

  const handleSaveGroup = async () => {
    const groupRoles = [];
    for (const roleId in rolePerms) {
      if (Object.hasOwnProperty.call(rolePerms, roleId) && rolePerms[roleId]) {
        groupRoles.push({
          rbacRoleId: roleId,
          rbacGroupId: selectedGroup.id
        });
      }
    }
    const payload = {
      name: groupName,
      groupRoles
    };
    if (selectedGroup.id) payload.id = selectedGroup.id;
    console.log('updateGroup', payload);
    // Updating a role
    updateGroup(payload);
  };

  // Load permissions
  // iterate permissions and set rolePermsView, roleAllView and manage...
  return (
    <Fragment>
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
        <ModalHeader>
          {selectedGroup.id ? 'Edit' : 'Create'} group: {selectedGroup.name}
        </ModalHeader>
        <ModalBody>
          {isReadOnly && (
            <Alert color="info">
              Note: Your user only has read-only access. You will not be able to save any updates.
            </Alert>
          )}
          <FormGroup lg="5">
            <FieldGroup
              type="text"
              label="Group Name"
              id="groupName"
              onChange={e => setGroupName(e.target.value)}
              value={groupName}
              placeholder="group name..."
              help="Choose a unique name for your group."
              required
              feedback="Please specify a unique group name"
              showFeedback={groupName.length === 0}
              data-testid={'group-name'}
            />
          </FormGroup>

          <CardTitle data-testid={'kw-exclude-title'}>Roles</CardTitle>
          <Table bordered striped style={{ marginTop: '20px' }}>
            <thead className="card-header">
              <tr>
                <th>Name</th>
                <th>Assigned</th>
              </tr>
            </thead>
            <tbody>
              {roles?.length ? (
                roles.map(role => {
                  return (
                    <tr key={role.id} id={role.id} className="font-weight-bold" data-testid={'role-row'}>
                      <td>
                        <div className="py-2">{role.name}</div>
                      </td>
                      <td>
                        {' '}
                        <FormGroup check>
                          <Input
                            id={`role-manage-${role.id}`}
                            type="checkbox"
                            checked={!!rolePerms[role.id]}
                            onChange={() => {
                              if (!rolePerms[role.id]) handleSetRole(role.id, true);
                              else handleSetRole(role.id, !rolePerms[role.id]);
                            }}
                            data-testid={'role-manage-checkbox'}
                          />
                          <Label for={`role-manage-${role.id}`} check data-testid={'role-all-manage-label'}>
                            {' '}
                            Assigned
                          </Label>
                        </FormGroup>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr className="font-weight-bold">
                  <td>No roles found.</td>
                  <td />
                </tr>
              )}

              <tr />
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <>
            <Button color="falcon-danger" onClick={() => setModalOpen(!modalOpen)} data-testid={'cancel-btn'}>
              Cancel
            </Button>
            <LoaderButton
              color="falcon-primary"
              disabled={
                isReadOnly ||
                !groupName.length ||
                (!selectedGroup.id && rbacGroups?.some(group => group.name === groupName))
              }
              onClick={handleSaveGroup}
              isLoading={loader}
              size="sm"
              name="save-and-add"
            >
              Save group
            </LoaderButton>
          </>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

InputGroupModal.propTypes = {
  isReadOnly: PropTypes.bool,
  isLoading: PropTypes.bool,
  handleSave: PropTypes.func,
  groupRbacRoles: PropTypes.array,
  roles: PropTypes.array,
  setModalOpen: PropTypes.func,
  modalOpen: PropTypes.bool,
  updateGroup: PropTypes.func,
  loader: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  selectedGroup: PropTypes.object,
  setIsSubmitted: PropTypes.func,
  setSelectedGroup: PropTypes.func,
  rbacGroups: PropTypes.array
};

export default InputGroupModal;
